import { ClientConfig } from '@sanity/client';

import { Vertical } from './vertical';

export type VerticalConfig = {
  cms: ClientConfig;
  domain: string;
  theme: string;
};

export type VerticalConfigs = Record<Vertical, VerticalConfig>;

// These configs might be available in frontend, so don't add anything sensitive like secrets etc
const verticalConfigs: Record<Vertical, VerticalConfig> = {
  [Vertical.ARTIST]: {
    cms: {
      dataset: process.env.VERTICAL_ARTIST_DATASET ?? 'production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    domain: process.env.VERTICAL_ARTIST_DOMAIN ?? 'artists-support.spotify.com',
    theme: 'encore-creator-dark-theme',
  },
  [Vertical.CONSUMER]: {
    cms: {
      dataset: process.env.VERTICAL_CONSUMER_DATASET ?? 'production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    domain: process.env.VERTICAL_CONSUMER_DOMAIN ?? 'support.spotify.com',
    theme: 'encore-dark-theme',
  },
} as const;

const domainConfigs: Record<string, Vertical> = {
  [verticalConfigs[Vertical.ARTIST].domain]: Vertical.ARTIST,
  [verticalConfigs[Vertical.CONSUMER].domain]: Vertical.CONSUMER,
} as const;

export const getVerticalConfigs = (): Record<Vertical, VerticalConfig> => verticalConfigs;

export const getVerticalConfig = (vertical: Vertical): VerticalConfig => verticalConfigs[vertical];

export const getVertical = (domain: string): Vertical | undefined => domainConfigs[domain];
